import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoFaqWithImg from 'eco-design/sections/eco-faq-win-img';
export default function Comp() {
    const { t } = useLang('theProduct.FaqA');
    const itemsA = [
        {
            pc: 'https://www.apple.com/v/home/bo/images/promos/iphone-family/promo_iphone_family_a__fmgvq2o4ug66_large.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://www.apple.com/v/home/bo/images/promos/iphone-family/promo_iphone_family_a__fmgvq2o4ug66_large.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: 'https://www.apple.com/v/home/bo/images/promos/iphone-family/promo_iphone_family_a__fmgvq2o4ug66_large.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
    ];
    return (
        <>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <EcoFaqWithImg items={itemsA} />
            <EcoSpace />
        </>
    );
}
